<template>
<div class="date-input">
   <datepicker v-model="dateTimeValue" 
               input-class="input-datepicker" 
               :placeholder="defaultConfig.placeholder" 
               :clear-button="true" 
               :format="defaultConfig.dateFormat">
   </datepicker>
</div>
</template>

<script>
import moment from 'moment'
import Datepicker from 'vuejs-datepicker';

export default {

   name: 'DateInput',
   props: ['field', 'value'],
   components: {
      Datepicker
   },
   data() {
      return {
         defaultConfig: {
            placeholder: "- Select -",
            dateFormat: this.$timeConfig.formats.shortDate
         }
      }
   },
   computed: {
      dateTimeValue: {
         get() {
            return this.value;
         },
         set(value) {
            // it is must to switch "toString" methods because,
            // query-string library uses toString method directly to stringlify date and it
            // causes therefore invalid query string (URL) in browsers window
            if(value){
               value.setHours(0, 0, 0 ,0);
               value.toString = value.toISOString;
            }

            this.value = value
            this.$emit('input', value)
         }
      }
   },
   methods: {
   }
}
</script>

<style lang="scss" scoped>
@import "src/scss/variables";

.date-input {
   flex-basis: 55%;

   @media (max-width: 767px) {
      width: 100%;
   }
}

.date-input /deep/ .input-datepicker {
   min-height: 40px;
   display: block;
   padding: 8px 40px 5px 8px;
   border-radius: 5px;
   border-width: 1px;
   border-style: solid; 
   width: 100%;
   transition: 0.2s;
}

.date-input /deep/ .vdp-datepicker__clear-button {
   position: absolute;
   float: right;
   top: 25%;
   right: 5%;
}

.date-input /deep/ .vdp-datepicker__calendar .cell.selected {
    border-width: 1px;
    border-style: solid;
}

.date-input /deep/ .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {
    border-width: 1px;
    border-style: solid;
}

</style>



// WEBPACK FOOTER //
// src/components/custom-inputs/DateInput.vue